<template>
  <div>
    <div class="has-content">
      <div class="select-info">
        <div class="select-label">已选中工人信息</div>
        <f7-link class="select-button" @click="delAllWorker" v-if="perms.projectEntrust">
          重新指派
        </f7-link>
      </div>
    </div>
    <div class="has-content-margin select-no-data" v-if="(workerList || []).length === 0">
      暂无选择队伍或工人
    </div>
    <div class="has-content" v-else>
      <div>
        <f7-list
          media-list
          virtual-list
          class="search-list searchbar-found">
          <f7-list-item
            swipeout
            v-for="item in workerList" :key="item.id">
            <div slot="inner" class="worker-item">
              <div class="worker-avatar">
                <img style="width: 2.5rem; height: 2.5rem;"
                  :src="imageUrl+'?attachmentId='+item.headImage"
                  v-if="item.headImage"/>
                <img style="width: 2.5rem; height: 2.5rem;"
                  src="@/assets/img/avatar.png"
                  v-else/>
              </div>
              <div class="worker-text">
                <f7-link @click="callUserDetail(item.id)">
                  <div style="display: flex; align-items: start;">
                    <div style="color: #000000;">{{ item.name }}</div>
                    <competitiveness :score="item.score"></competitiveness>
                  </div>
                  <div class="worker-text-sub">
                    <f7-row no-gap style="padding: 0.5rem 0rem;">
                      <f7-col>
                        <span class="worker-text-type">
                          {{ (item.workTypeList || []).map(wt => wt.nameDesc).join('/') }}
                        </span>
                      </f7-col>
                    </f7-row>
                    <f7-row no-gap>
                      <f7-col>
                        <span class="worker-text-label">地区</span>
                        <span class="worker-text-value">{{ item.regionDesc || '--' }} &nbsp;</span>
                        <span class="worker-text-label">工龄</span>
                        <span class="worker-text-value">{{ item.workingYears }}</span>
                        <span class="worker-text-label">年 &nbsp;</span>
                        <span class="worker-text-label">当前任务</span>
                        <span class="worker-text-value">{{ item.currentTaskCount }}</span>
                      </f7-col>
                    </f7-row>
                  </div>
                </f7-link>
              </div>
            </div>
            <div slot="content" class="worker-after">
              <div style="width: 2.5rem;">
                <f7-link :href="`tel:${item.cellPhone}`">
                  <span class="worker-phone">
                    <f7-icon size="2rem" fa="phone"></f7-icon>
                  </span>
                </f7-link>
              </div>
            </div>
            <f7-swipeout-actions right v-if="perms.projectEntrust">
              <f7-swipeout-button
                color="red"
                @click="deleteItem(item.id)">
                删除
              </f7-swipeout-button>
            </f7-swipeout-actions>
          </f7-list-item>
        </f7-list>
      </div>
    </div>
    <f7-popup
      :opened="workerPopupOpened"
      @popup:closed="workerPopupOpened = false">
      <workers
        :opened="workerPopupOpened"
        :project-id.sync="projectId"
        :result.sync="workerList">
      </workers>
    </f7-popup>
  </div>
</template>
<script>
import { toPersonalDetail } from '@/util/native';
import { deleteWorker, getWorker, clearWorker } from '@/api/team/worker';
import { imageView } from '@/api/common';
import bus from '@/util/bus';
import Competitiveness from '@/components/Competitiveness';
import Workers from './workers';

export default {
  props: ['projectId', 'perms'],
  components: {
    Workers,
    Competitiveness,
  },
  data() {
    return {
      workerPopupOpened: false,
      imageUrl: imageView,
      workerList: [],
    };
  },
  created() {
    bus.$on('refreshAssign', () => {
      this.getList();
    });
    bus.$on('workerPopupOpened', (opened) => {
      this.workerPopupOpened = opened;
    });
  },
  mounted() {
    this.getList();
  },
  methods: {
    callUserDetail(id) {
      toPersonalDetail('workmate', id);
    },
    delAllWorker() {
      this.$f7.dialog.confirm(`确认重新指派吗？<br>
      <div style="text-align: left;">
      确认后将删除已经指派队伍或工人，并同时删除以下信息：<br>
      -已经签订的合同信息<br>
      -施工日志信息<br>
      -各种验收信息<br>
      -评价信息<br>
      -各种消息/通知/群成员信息<br><br>
      <div>`, '温馨提示', () => {
        clearWorker({ projectId: this.projectId }).then((result) => {
          if (result.code === 0) {
            bus.$emit('refreshAssign');
            this.getList();
          }
        });
      });
    },
    getList() {
      getWorker({ projectId: this.projectId }).then((result) => {
        if (result.code === 0) {
          this.workerList = result.data || [];
        }
      });
    },
    deleteItem(workerId) {
      this.$f7.dialog.confirm('确认删除此工人吗', '温馨提示', () => {
        deleteWorker({ projectId: this.projectId, workerIdList: [workerId] }).then((result) => {
          if (result.code === 0) {
            const index = this.workerList.findIndex(item => item.id === workerId);
            if (index >= 0) {
              this.workerList.splice(index, 1);
            }
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .select-no-data {
    border-radius: 0.5rem;
    background-color: $panel-bg-color;
    text-align: center;
    line-height: 8rem;
    height: 8rem;
    font-size: 1rem;
    padding: 0rem 10px;
    color: #B6B6B6;
  }

  .select-info {
    padding: 0rem 0.5rem;
    line-height: 2rem;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    background-color: #CAE8EA;
  }

  .select-label {
    color: $font-color;
    flex: auto;
  }

  .select-button {
    color: #787878;
  }

  .worker-item {
    font-size: 1rem;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .worker-avatar {
    width: 2.5rem;
    margin-right: 0.5rem;
    text-align: center;
  }

  .worker-text {
    font-size: 1rem;
    width: 100%;
  }

  .worker-auth {
    min-width: 2.5rem;
    margin-right: 0.3rem;
    margin-left: 1rem;
    margin-top: 0.2rem;
    padding: 0rem 0.2rem;
    height: 1rem;
    font-size: 0.8rem;
    border: 0.05rem solid red;
    border-radius: 0.2rem;
  }

  .worker-text-sub {
    font-size: 0.8rem;
  }

  .worker-text-type {
    /* background-color: #EEEEEE;
    border-radius: 0.2rem;
    padding: 0rem 0.2rem; */
    height: 150%;
    color: #999999;
  }

  .worker-text-label {
    color: #999999;
  }

  .worker-text-value {
    color: #FF9403;
  }

  .worker-after {
    display: flex;
    align-items:center;
    justify-content:center;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    color: #FF9403;
    font-size: 0.6rem;
    text-align: center;
  }

  .worker-phone {
    color: #FF9403;
  }

  .select-no-data {
    border-radius: 0.5rem;
    background-color: #EEEEEE;
    text-align: center;
    line-height: 8rem;
    height: 8rem;
    font-size: 1rem;
    padding: 0rem 10px;
    color: #B6B6B6;
  }

  .select-info {
    padding: 0rem 0.5rem;
    line-height: 2rem;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    background-color: #CAE8EA;
  }

</style>



// WEBPACK FOOTER //
// src/pages/team/assignWorker.vue